import CustomerReferenceField from "./CustomerReferenceField";
import CustomerIcon from "../unit/svgIcon/CustomerIcon";
import CustomerYearList from "./CustomerYearList";

const UserIcon = () => {
  return <CustomerIcon color="white" size="20.8px" />;
};

export default {
  icon: UserIcon,
  CustomerReferenceField: CustomerReferenceField,
  list: CustomerYearList,
};
